export enum TipoPessoaEnum {
    PCD = "PCD",
    REPRESENTANTE = "REPRESENTANTE",
    OUTROS = "OUTROS"
}
